import React, { useEffect, useState } from "react";
import { Wifi, ShieldCheck, Users, HardDrive, Zap } from "lucide-react";

export default function BottomStatusBar({ stats, bitrate = 128, isPlaying = false, peerName = "trusted-swarm" }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid="bottom-status-bar"
      className="flex items-center gap-1.5 px-2 py-1.5 border-t-2 border-[#808080]"
      style={{ background: "linear-gradient(to bottom, #D4D0BF 0%, #ECE9D8 50%, #D4D0BF 100%)" }}
    >
      <Chip data-testid="chip-connected">
        <span className="led-green pulse-green" />
        <span className="font-bold text-[#1F8020]">Connected</span>
        <span className="text-[10px] text-[#555] font-mono">({peerName})</span>
      </Chip>

      <Chip data-testid="chip-viruses">
        <ShieldCheck size={12} className="text-[#1F8020]" />
        <b className="text-[#1F8020]">0 viruses</b>
      </Chip>

      <Chip data-testid="chip-bitrate">
        <Zap size={12} className="text-[#003c9e]" />
        <span className="font-mono font-bold">{bitrate} kbps</span>
        {isPlaying && <span className="text-[#1F8020] blink">●</span>}
      </Chip>

      <Chip data-testid="chip-peers">
        <Users size={12} className="text-[#003c9e]" />
        <span className="font-mono font-bold">{(stats?.peers_online || 248392).toLocaleString()}</span>
        <span className="text-[10px] text-[#555]">trusted peers</span>
      </Chip>

      <Chip data-testid="chip-files">
        <HardDrive size={12} className="text-[#003c9e]" />
        <span className="font-mono font-bold">{(stats?.shared_files || 4923348).toLocaleString()}</span>
        <span className="text-[10px] text-[#555]">files</span>
      </Chip>

      <Chip data-testid="chip-network">
        <Wifi size={12} className="text-[#1F8020]" />
        <span className="font-mono">{stats?.connection || "T1/DSL"}</span>
      </Chip>

      <div className="flex-1" />

      <Chip data-testid="chip-ping">
        <span className="text-[10px] text-[#555]">Ping</span>
        <span className="font-mono font-bold">{stats?.ping_ms ?? 64}ms</span>
      </Chip>

      <Chip data-testid="chip-uptime">
        <span className="text-[10px] text-[#555]">Uptime</span>
        <span className="font-mono font-bold">{stats?.uptime_days ?? 97}d</span>
      </Chip>

      <Chip data-testid="chip-clock" className="min-w-[70px] justify-center">
        <span className="font-mono">
          {now.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}
        </span>
      </Chip>
    </div>
  );
}

function Chip({ children, className = "", ...props }) {
  return (
    <div {...props} className={`status-chip ${className}`}>
      {children}
    </div>
  );
}
